export default __webpack_public_path__ + "static/media/initial-center.f373cca3.png";